import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Box from 'components/Box';
import Icon from 'components/Icon';
import TextLink from 'components/TextLink';
import useBackLink from 'hooks/useBackLink';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PageBackLink(_ref) {
  var children = _ref.children,
    to = _ref.to,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? '/' : _ref$fallback,
    basePath = _ref.basePath,
    shouldSkipLocation = _ref.shouldSkipLocation,
    _ref$mb = _ref.mb,
    mb = _ref$mb === void 0 ? 'm' : _ref$mb,
    mt = _ref.mt;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var backLink = useBackLink({
    shouldSkipLocation: shouldSkipLocation,
    basePath: basePath,
    fallback: fallback
  });
  return /*#__PURE__*/_jsx(Box, {
    mb: mb,
    mt: mt,
    children: /*#__PURE__*/_jsxs(TextLink, {
      bold: true,
      as: Link,
      to: to || backLink,
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "arrow",
        vAlign: true,
        mr: "xxs"
      }), children || t('actions_back')]
    })
  });
}
export default PageBackLink;